import { eachDayOfInterval, endOfWeek, format, startOfWeek } from 'date-fns';
import React, { useMemo } from 'react';
export function DaysOfWeekHeader({ dataTestId = 'week-header', dataMetrics, weekStartsOn }) {
    const days = useMemo(() => {
        const arbitraryDate = new Date();
        return eachDayOfInterval({
            start: startOfWeek(arbitraryDate, { weekStartsOn }),
            end: endOfWeek(arbitraryDate, { weekStartsOn })
        });
    }, [weekStartsOn]);
    return (React.createElement("div", { "data-testid": dataTestId, "data-metrics": dataMetrics, role: "rowgroup", className: "twds-flex twds-flex-col twds-px-4 twds-py-2" },
        React.createElement("div", { role: "row", className: "twds-flex twds-gap-x-3" }, days.map((day) => (React.createElement("div", { "data-testid": `${dataTestId}-${format(day, 'EEEEEE')}`, "data-metrics": dataMetrics, key: format(day, 'EEEEEE'), role: "columnheader", "aria-label": format(day, 'EEEE'), className: "twds-flex twds-items-center twds-justify-center twds-w-7 twds-h-7 twds-text-xs twds-text-gray-600 dark:twds-text-gray-300  twds-leading-4.5" }, format(day, 'EEEEE')))))));
}
//# sourceMappingURL=days_of_week_header.js.map